<template>
  <div>
    <label>
      {{ $t("geral.exportType") }}
    </label>
    <pdf-attachment-mode v-model="optionMode" :model.sync="optionMode" />

    <div v-if="optionMode == 1 || optionMode == 3 || optionMode == 5">
      <label>
        {{ $t("checklist.modalPdf.attachmentSize") }}
      </label>
      <b-form-select v-model="optionSize" :options.sync="option" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PdfAttachmentMode: () =>
      import("@/components_rms/checklist/fill/PdfAttachmentMode.vue"),
  },

  props: {
    params: {
      type: Object,
      required: true,
      default: () => ({
        optionMode: 1,
        optionSize: 1,
      }),
    },
  },

  data() {
    return {
      optionMode: 1,
      optionSize: 1,
      option: [
        { value: 1, text: "Pequeno" },
        { value: 2, text: "Médio" },
        { value: 3, text: "Grande" },
      ],
    };
  },

  mounted() {
    this.optionMode = this.params.optionMode;
    this.optionSize = this.params.optionSize;
  },

  watch: {
    optionMode(ctx) {
      this.$emit("update:params", { ...this.params, optionMode: ctx });
    },
    optionSize(ctx) {
      this.$emit("update:params", { ...this.params, optionSize: ctx });
    },
  },
};
</script>